function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMusic = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 46 46",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.149,
    y: 0.903,
    width: 44,
    height: 44,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.242,5.348C39.811,5.77 40.149,6.445 40.149,7.155L40.149,30.78C40.149,33.888 37.125,36.405 33.399,36.405C29.672,36.405 26.649,33.888 26.649,30.78C26.649,27.672 29.672,25.155 33.399,25.155C34.186,25.155 34.946,25.267 35.649,25.478L35.649,15.241L17.649,20.641L17.649,35.28C17.649,38.388 14.625,40.905 10.899,40.905C7.172,40.905 4.149,38.388 4.149,35.28C4.149,32.172 7.172,29.655 10.899,29.655C11.686,29.655 12.446,29.767 13.149,29.978L13.149,13.905C13.149,12.913 13.803,12.035 14.752,11.746L37.252,4.996C37.934,4.792 38.672,4.919 39.242,5.348Z",
    style: {
      fill: "#00659d",
      fillRule: "nonzero"
    }
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMusic);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/music.73538d506743591d1b54034a318816f7.svg";